<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="col-md-11 d-flex justify-content-end">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createTipoMoneda">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-if="listTipoMoneda != 0">
            <md-table md-card md-header v-model="listTipoMoneda">
                <md-table-row slot="md-table-row" slot-scope="{ item }" @click="editTipoMoneda(item.id)">
                    <md-table-cell :md-label="labels.codMoneda" class="border">{{ item.moneda }}</md-table-cell>
                    <md-table-cell :md-label="labels.descripcion" class="border text-left">{{ item.descripcion }}</md-table-cell>
                    <md-table-cell :md-label="labels.acronimo" class="border text-left">{{ item.acronimo }}</md-table-cell>
                </md-table-row>
            </md-table>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <Crear :modCrearTipoMoneda="showCrearTipMoneda" @cierraModal="closeModal"></Crear>
        <Editar :modEditarTipoMoneda="showEditarTipMoneda" :infoTipoMoneda="dataTipMoneda" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import TipoMoneda from '../../../services/TipoMoneda';
import Crear from './Crear.vue';
import Editar from './Editar.vue';

export default {
    name : 'Tipo moneda',
    components: {Crear,Editar},
    data : () => ({
        listTipoMoneda : [],
        showCrearTipMoneda : false,
        showEditarTipMoneda : false,
        dataTipMoneda : []
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Tipo moneda',
                    noRow : "No hay registros",
                    codMoneda : 'Código',
                    descripcion : 'Descripción',
                    acronimo : 'Acrónimo'
                }
            }else{
                return {
                    title : 'Currency type',
                    noRow : "There are not records",
                    codMoneda : 'Code',
                    descripcion : 'Description',
                    acronimo : 'Acronym'
                }
            }
        }
    },
    methods:{
        createTipoMoneda(){
            this.showCrearTipMoneda = true
        },
        editTipoMoneda(id){
            TipoMoneda.getTipoMonedaById(id)
            .then((res) => {
                this.dataTipMoneda = res.data.tipoMoneda
                this.showEditarTipMoneda = true
            })
            .catch((err) => console.log(err))
        },
        closeModal(val){
            this.showCrearTipMoneda = val
            this.showEditarTipMoneda = val
        }
    },
    mounted(){
        TipoMoneda.getAllTipoMoneda()
        .then((res) => {
            // console.log(res.data.listTipoMoneda);
            this.listTipoMoneda = res.data.listTipoMoneda
        })
        .catch((error) => console.log(error))
    }
}
</script>

<style>

</style>